var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw:min-h-screen tw:flex tw:items-center tw:justify-center tw:bg-gray-50"},[_c('div',{staticClass:"tw:max-w-md tw:w-full tw:p-6"},[_c(_setup.InstantCreditStatus,{attrs:{"phase":_setup.phase,"final-state":_setup.finalState,"error":_setup.error,"polling":_setup.polling}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }